import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SAVED_USER_TOKEN } from '../../../constants/constants';

interface IInitialState {
    savedUserToken: string | null;
}

const storedSavedUserToken= localStorage.getItem(SAVED_USER_TOKEN);
const initialSavedUserToken: string | null = storedSavedUserToken ? JSON.parse(storedSavedUserToken) : null;

const initialState: IInitialState = {
    savedUserToken: initialSavedUserToken,
};

const savedUserTokenSlice = createSlice({
    name: 'savedUserToken',
    initialState,
    reducers: {
        saveUserSettingsToken: (state: IInitialState, action: PayloadAction<string>) => {
            state.savedUserToken = action.payload;
            localStorage.setItem(SAVED_USER_TOKEN, JSON.stringify(action.payload));
        },

        removeUserSettingsToken: (state: IInitialState) => {
            state.savedUserToken = null;
            localStorage.removeItem(SAVED_USER_TOKEN);
        },
    },
});

export default savedUserTokenSlice.reducer;
export const { saveUserSettingsToken, removeUserSettingsToken } = savedUserTokenSlice.actions;
